import { render, staticRenderFns } from "./Lobby.vue?vue&type=template&id=7475ecd6&"
import script from "./Lobby.vue?vue&type=script&lang=ts&"
export * from "./Lobby.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7475ecd6')) {
      api.createRecord('7475ecd6', component.options)
    } else {
      api.reload('7475ecd6', component.options)
    }
    module.hot.accept("./Lobby.vue?vue&type=template&id=7475ecd6&", function () {
      api.rerender('7475ecd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Lobby.vue"
export default component.exports